import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UsersService } from "src/app/manage-users/services/user-services/users.service";

import { MatDialog } from "@angular/material/dialog";
import {
  MatPaginator,
  MatPaginatorIntl,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SessionsService } from "src/app/services/session/sessions.service";

import { SesionDetailsComponent } from "../../../reports/components/sesion-details/sesion-details.component";

import {
  EnumAssistanceStatus,
  IAttendant,
  IEventAndSessionData,
  IReporteAsistenciaSession,
  ISession,
  ISetGradeObj,
} from "../../../reports/interfaces/reports.interfaces";

import * as XLSX from "xlsx";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { ModalSharedServiceService } from "src/app/shared/modals/modal-service.service";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { AssistanceService } from "src/app/attendanceRecord/services/asistanceService/assistance.service";
import { CatalogService } from "src/app/catalog/services/catalog.service";
import {
  ICalendarCatalog,
  ICatalogItem,
} from "src/app/catalog/interfaces/catalog.interface";
import { from, Subject, switchMap, take, takeUntil } from "rxjs";
import { GeneralEmptyModalComponent } from "src/app/shared/modals/general-empty-modal/general-empty-modal.component";
import { ModalConfig } from "src/app/shared/modals/modal.interfaces";
import { formatDate } from "@angular/common";
import { IOffCanvasOptions } from "src/app/shared/off-canvas/off-canvas.interface";
import { OffCanvasComponent } from "src/app/shared/off-canvas/off-canvas.component";
import { IUser } from "src/app/models/Identity/user";

@Component({
  selector: "app-modal-share-qr-attendance",
  templateUrl: "./modal-share-qr-attendance.component.html",
  styleUrls: ["./modal-share-qr-attendance.component.css"],
})
export class ModalShareQrAttendanceComponent implements OnInit, OnDestroy {
  // Variables
  public user: IUser | null = null;
  public userList: IUser[] = [];

  /**Datos de entrada desde la tabla, Visualizar Detalle del Usuario */
  selectedPageSize: number = 10;
  attendancesList!: any[];
  dataSource: MatTableDataSource<IAttendant> = new MatTableDataSource();
  displayedColumns: string[] = [
    "code",
    "name",
    "curp",
    "email",
    "date",
    "numeroSesion",
    "status",
  ];

  coursesSessions: ICourseSession[] = new Array();
  selectedCourseSession?: ICourseSession;
  sessions: ISession[] = new Array();
  selectedSession: number = -1; // -1 is used for getting assitance for all the sessions
  reporteAsistenciasSessions: IReporteAsistenciaSession | null = null;
  unAlteredAttendants: IAttendant[] = [];

  // flags
  isLoadingSessions: boolean = false;
  detailSessionButton: boolean = true;
  isQueueAssistancesLoading: boolean = false;
  spinner: boolean = false;
  showSelectCourseError: boolean = false;
  isAssistanceLoading: boolean = false;
  showGradeColumn: boolean = false;
  showMissingPartsColumn: boolean = false;
  gradesTouched: boolean = false;
  showsAllSessionsAttendance: boolean = false;
  errorOnGetAttendance: boolean = false;
  isLoadingGrades: boolean = false;
  isModalOpen: boolean = false;

  deletingAttendant: number | null = null;
  gettingAttendantDetails: IAttendant | null = null;

  // year filter
  selectedYear?: number;
  // catalogs
  yearList: ICalendarCatalog[] = [];
  justificationList: ICatalogItem[] = [];

  private unsubscribe$ = new Subject<void>();

  // offcanvas
  @ViewChild("offcanvasAttendanceComponent")
  offcanvasComponent!: OffCanvasComponent;
  protected offCanvasOptions: IOffCanvasOptions = {
    title: "Detalles de asistencia",
    ngbOptions: {
      keyboard: true,
      position: "end",
      beforeDismiss: () => {
        this.gettingAttendantDetails = null;
        this.offCanvasOptions.title = "Detalles de asistencia";
        return true;
      },
    },
  };

  @ViewChild(MatPaginator) paginatorSet!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private sessionsService: SessionsService,
    private _userService: UsersService,
    private assistanceService: AssistanceService,
    private catalogService: CatalogService,
    private dialog: MatDialog,
    private authService: AuthenticationService,
    private paginator: MatPaginatorIntl,
    private sharedModalService: ModalSharedServiceService,
    private route: ActivatedRoute
  ) {
    this.paginator.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = params["Id"]; // 'id' should match the parameter name in your route definition
      this.loadReport(id);
      this.getSession(id);
    });

    this._userService.getUsers().subscribe(users => {
      this.userList = users.filter(usr => usr.status == 1);
      this.user =
        this.userList.find(
          usr => usr.personNumber === this.selectedCourseSession?.numeroPersona
        ) || null;
    });
  }

  updateData(): void {
    this.route.params.subscribe(params => {
      const id = params["Id"]; // 'id' should match the parameter name in your route definition
      this.loadReport(id);
      this.getSession(id);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onChange() {
    this.updateData();
  }

  // Función de comparación genérica
  private compare(a: any, b: any, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  get eventAndSessionData(): IEventAndSessionData | undefined {
    if (!this.selectedCourseSession || !this.selectedYear) {
      return undefined;
    }
    return {
      eventName: this.selectedCourseSession.nombreEvento,
      locatorId: this.selectedCourseSession.IdLocalizador,
      sessionName: this.selectedCourseSession.titulo,
      fkObjectIdExt: this.selectedCourseSession.fkObjectIdExt,
      yearId: this.selectedYear,
    };
  }

  getFullName(attendant: IAttendant, lastNameFirst: boolean = false) {
    const firstNames = [attendant.nombre ?? "", attendant.segundoNombre ?? ""];

    const lastNames = [
      attendant.apellidoPaterno ?? "",
      attendant.apellidoMaterno ?? "",
    ];

    return lastNameFirst
      ? `${lastNames.join(" ").trim()} ${firstNames.join(" ").trim()}`.trim()
      : `${firstNames.join(" ").trim()} ${lastNames.join(" ").trim()}`.trim();
  }

  getStatusInfoByNumber(statusId: EnumAssistanceStatus) {
    switch (statusId) {
      case EnumAssistanceStatus.completeInfo:
        return "Completo - no integrado";
      case EnumAssistanceStatus.incompleteInfo:
        return "Incompleto - no integrado";
      case EnumAssistanceStatus.integrated:
        return "Integrado en GB University";
      default:
        return "";
    }
  }

  private initMatTableData(attendants: IAttendant[]) {
    this.dataSource = new MatTableDataSource<IAttendant>(attendants);
    this.dataSource.paginator = this.paginatorSet;
    this.dataSource.sort = this.sort;
  }

  loadReport(idSesion: number) {
    const id = idSesion;
    if (!id) {
      return;
    }
    this.isAssistanceLoading = true;
    const getReportObservable =
      this.selectedSession === -1 // -1 is used for getting assitance for all the sessions
        ? this.sessionsService.getReporteAsistenciaSession(id)
        : this.sessionsService.getReporteAsistenciaSession(
            id,
            this.selectedSession
          );
    getReportObservable.subscribe({
      next: response => {
        this.reporteAsistenciasSessions = response;
        this.unAlteredAttendants = structuredClone(response.participantes);
        this.showsAllSessionsAttendance = this.selectedSession === -1;
        this.initMatTableData(this.reporteAsistenciasSessions.participantes);
        //this.toggleMissingPartsColumn(this.showsAllSessionsAttendance);
        // if response already has grades, show grades column
        //this.toggleGradesColumn(this.getOgAttendantsHaveGrades);
        this.gradesTouched = false;
        this.isAssistanceLoading = false;
        this.errorOnGetAttendance = false;
      },
      error: () => {
        this.reporteAsistenciasSessions = null;
        this.gradesTouched = false;
        this.isAssistanceLoading = false;
        this.errorOnGetAttendance = true;
      },
    });
  }

  loadSessions(partes: number) {
    this.sessions = new Array();
    var numeroSesiones: number = partes;
    if (this.selectedCourseSession?.QrMeastro) {
      numeroSesiones = 1;
    }

    for (let i = 0; i < numeroSesiones; i++) {
      this.sessions.push({ value: i + 1, showValue: i + 1 });
    }
    this.showSelectCourseError = false;
  }

  getSelectedItem(id: any): number {
    for (const courseSession of this.coursesSessions) {
      if (courseSession.Id === id) {
        this.selectedCourseSession = courseSession;
        this.detailSessionButton = false;
        return this.selectedCourseSession?.TotalPartes || 0;
      }
    }
    return 0;
  }

  onPageSizeChange(event: PageEvent) {
    this.selectedPageSize = event.pageSize;
    // this.dataSource.paginator = this.paginatorSet;
  }

  // offcanvas
  openOffcanvas(attendant: IAttendant) {
    this.gettingAttendantDetails = attendant;
    this.offcanvasComponent.open();
  }

  sortData(sort: Sort) {
    if (!this.reporteAsistenciasSessions) {
      return;
    }
    const sortedData = this.reporteAsistenciasSessions.participantes.slice();

    if (!sort.active || sort.direction === "") {
      this.dataSource = new MatTableDataSource<IAttendant>(sortedData);
      this.dataSource.paginator = this.paginatorSet;
      this.dataSource.sort = this.sort;
      return;
    }

    // Use sort directly on the data array without assigning its return value
    sortedData.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "code":
          return this.compare(a.numeroPersona, b.numeroPersona, isAsc);
        case "curp":
          return this.compare(a.curp, b.curp, isAsc);
        case "name":
          return this.compare(
            `${a.nombre} ${a.apellidoPaterno} ${a.apellidoPaterno}`,
            `${b.nombre} ${b.apellidoPaterno} ${b.apellidoPaterno}`,
            isAsc
          );
        case "email":
          return this.compare(a.email, b.email, isAsc);
        case "numeroSesion":
          return this.compare(a.numeroSesion, b.numeroSesion, isAsc);
        case "status":
          return this.compare(
            a.idSesionAsistenciaEstatus,
            b.idSesionAsistenciaEstatus,
            isAsc
          );
        case "date":
          return this.compare(a.fechaRegistro, b.fechaRegistro, isAsc);
        case "grades":
          return this.compare(a.calificacion, b.calificacion, isAsc);
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource<IAttendant>(sortedData);
    this.dataSource.paginator = this.paginatorSet;
    this.dataSource.sort = this.sort;
  }

  getSession(idSesion: number) {
    const id = idSesion;
    if (!id) {
      return;
    }
    this.isAssistanceLoading = true;

    const getSessionObservable = this.sessionsService.getSessionBySessionId(id);
    getSessionObservable.subscribe({
      next: response => {
        this.selectedCourseSession = response;
        this.loadSessions(this.selectedCourseSession.totalPartesReales);
      },
      error: () => {
        this.selectedCourseSession = undefined;
      },
    });
  }

  getCompartidoPor(numPersona: string) {}
}
